export default "__VITE_ASSET__CzTFTMjJ__"